var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.101 2.27008C12.3733 2.27008 12.6 2.49618 12.6 2.78387V3.04987C12.6 3.33057 12.3733 3.56366 12.101 3.56366H0.499697C0.226702 3.56366 0 3.33057 0 3.04987V2.78387C0 2.49618 0.226702 2.27008 0.499697 2.27008H2.5407C2.9553 2.27008 3.31611 1.97538 3.40938 1.55958L3.51626 1.08219C3.68238 0.431896 4.22905 0 4.85469 0H7.74531C8.36415 0 8.91694 0.431896 9.07693 1.04789L9.1913 1.55888C9.28389 1.97538 9.64471 2.27008 10.06 2.27008H12.101ZM11.0641 11.9937C11.2772 10.0079 11.6502 5.28991 11.6502 5.24231C11.6639 5.09811 11.6169 4.96161 11.5236 4.85171C11.4235 4.74881 11.2969 4.68791 11.1574 4.68791H1.44797C1.30773 4.68791 1.1743 4.74881 1.08171 4.85171C0.987761 4.96161 0.941468 5.09811 0.948276 5.24231C0.949527 5.25106 0.962913 5.41724 0.985293 5.69508C1.08472 6.92935 1.36163 10.367 1.54056 11.9937C1.66719 13.1921 2.4535 13.9453 3.59245 13.9726C4.47135 13.9929 5.37679 13.9999 6.30266 13.9999C7.17475 13.9999 8.06045 13.9929 8.96658 13.9726C10.145 13.9523 10.9307 13.2124 11.0641 11.9937Z",
    fill: "#E43D3D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.ef07e75f1ed0fa62d99ffba9c1a20339.svg";
export { ForwardRef as ReactComponent };